// Cattle module constants. See CATTLE_DESIGN.md for full module design.
// Verbatim lift from main.jsx (Phase 2 finale) — no value changes.

export const CATTLE_HERDS = ['mommas', 'backgrounders', 'finishers', 'bulls'];
export const CATTLE_OUTCOMES = ['processed', 'deceased', 'sold'];
export const CATTLE_ALL_HERDS = [...CATTLE_HERDS, ...CATTLE_OUTCOMES];

export const CATTLE_HERD_LABELS = {
  mommas: 'Mommas',
  backgrounders: 'Backgrounders',
  finishers: 'Finishers',
  bulls: 'Bulls',
  processed: 'Processed',
  deceased: 'Deceased',
  sold: 'Sold',
};

// ── CATTLE BREEDING CONSTANTS ──
export const CATTLE_BULL_EXPOSURE_DAYS = 65;
export const CATTLE_PREG_CHECK_OFFSET_DAYS = 30; // days after bull_exposure_end
export const CATTLE_GESTATION_DAYS = 274; // ~9 months
export const CATTLE_CALVING_WINDOW_DAYS = 65;
export const CATTLE_NURSING_DAYS = 213; // ~7 months
